module.exports = __webpack_public_path__ + "static/commerce-8f7d05e7f25d38584f5239ed898c6aa5.svg";